@import '../../shared';

div.border-bottom {
  border-bottom: 1px solid var(--rds-color-border-default);
}

rass-summary-content {
  overflow: auto;
}
